import { Component } from '@angular/core';

@Component({
  selector: 'app-time-tracking',
  standalone: true,
  imports: [],
  templateUrl: './time-tracking.component.html',
  styleUrl: './time-tracking.component.scss'
})
export class TimeTrackingComponent {

}
